(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2393],{

/***/ 49044:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TagColor */
/* harmony import */ var _home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59499);
/* harmony import */ var _home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Tag_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28742);
/* harmony import */ var _Tag_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Tag_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


var _excluded = ["color"];




var TagColor;

(function (TagColor) {
  TagColor["Default"] = "default";
  TagColor["Station"] = "station";
  TagColor["Gray"] = "gray";
})(TagColor || (TagColor = {}));

var Tag = function Tag(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? TagColor.Default : _ref$color,
      props = (0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  var classes = classnames__WEBPACK_IMPORTED_MODULE_0___default()((_Tag_module_scss__WEBPACK_IMPORTED_MODULE_4___default().Tag), (0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (_Tag_module_scss__WEBPACK_IMPORTED_MODULE_4___default().isGray), color === TagColor.Station), (0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (_Tag_module_scss__WEBPACK_IMPORTED_MODULE_4___default().isGray), color === TagColor.Gray), props.className);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
    className: classes,
    children: props.children
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Tag);

/***/ }),

/***/ 56922:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ MultipleLineTruncate; },
/* harmony export */   "d": function() { return /* binding */ SingleLineTruncate; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_lines_ellipsis__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37188);
/* harmony import */ var react_lines_ellipsis_lib_html__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86181);
/* harmony import */ var react_lines_ellipsis_lib_html__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_lines_ellipsis_lib_html__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_lines_ellipsis_lib_responsiveHOC__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16028);
/* harmony import */ var react_lines_ellipsis_lib_responsiveHOC__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_lines_ellipsis_lib_responsiveHOC__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var xss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68924);
/* harmony import */ var xss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(xss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _utils_StringUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16197);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);







var ResponsiveHTMLEllipsis = react_lines_ellipsis_lib_responsiveHOC__WEBPACK_IMPORTED_MODULE_3___default()()((react_lines_ellipsis_lib_html__WEBPACK_IMPORTED_MODULE_2___default())); // SingleLineTruncateは responsiveHOC()(LineEllipsis) をそのまま使う

var SingleLineTruncate = react_lines_ellipsis_lib_responsiveHOC__WEBPACK_IMPORTED_MODULE_3___default()()(react_lines_ellipsis__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);

// MultipleLineTruncateは渡された文字列をエスケープした後に、改行を<br>タグに変換して表示します
var MultipleLineTruncate = function MultipleLineTruncate(_ref) {
  var className = _ref.className,
      maxLine = _ref.maxLine,
      onReflow = _ref.onReflow,
      text = _ref.text;
  // 先にエスケープしてしまう
  var escaped = (0,xss__WEBPACK_IMPORTED_MODULE_4__.filterXSS)(text); // 改行を<br>に変更

  var unsafeHTML = _utils_StringUtils__WEBPACK_IMPORTED_MODULE_5__/* ["default"].nl2brString */ .Z.nl2brString(escaped);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(ResponsiveHTMLEllipsis, {
    className: className,
    unsafeHTML: unsafeHTML,
    maxLine: maxLine,
    ellipsis: "...",
    basedOn: "letters",
    onReflow: onReflow
  });
};



/***/ }),

/***/ 51295:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ usePushMerchantDataLayerEffect; },
/* harmony export */   "U": function() { return /* binding */ usePushPurchaseEventToDataLayer; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _api_me__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21966);
/* harmony import */ var _utils_gtag__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7788);



var usePushMerchantDataLayerEffect = function usePushMerchantDataLayerEffect(params) {
  var _useUserMe = (0,_api_me__WEBPACK_IMPORTED_MODULE_1__/* .useUserMe */ .J1)(),
      user = _useUserMe.user,
      isUserLoading = _useUserMe.isUserLoading;

  var loginMerchantId = (user === null || user === void 0 ? void 0 : user.role) === 'admin' ? user.id : undefined;
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (isUserLoading) return;
    window.gtmDataLayer = window.gtmDataLayer || [];
    window.gtmDataLayer.push({
      login_user_id: user === null || user === void 0 ? void 0 : user.id,
      visit_merchant_id: params.visit_merchant_id,
      login_merchant_id: loginMerchantId
    });
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      login_user_id: user === null || user === void 0 ? void 0 : user.id,
      visit_merchant_id: params.visit_merchant_id,
      login_merchant_id: loginMerchantId
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, isUserLoading]);
};
var usePushPurchaseEventToDataLayer = function usePushPurchaseEventToDataLayer(params) {
  var isPurchaseEventSent = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (!isPurchaseEventSent.current) {
      _utils_gtag__WEBPACK_IMPORTED_MODULE_2__/* .purchaseEvent */ .mG({
        step: 'completion',
        productPublicId: params.productId,
        customerPublicId: params.customerId
      });
      isPurchaseEventSent.current = true;
    }
  });
};

/***/ }),

/***/ 13656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ useLineLiffAccessToken; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50029);
/* harmony import */ var _home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



var useLineLiffAccessToken = function useLineLiffAccessToken(liffId) {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null),
      lineAccessToken = _useState[0],
      setLineAccessToken = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    __webpack_require__.e(/* import() */ 9601).then(__webpack_require__.t.bind(__webpack_require__, 89601, 23)).then( /*#__PURE__*/function () {
      var _ref = (0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(_liff) {
        var liff, isNotLiffInitialized, initLineLiffApp, setToken;
        return _home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                liff = _liff["default"];

                isNotLiffInitialized = function isNotLiffInitialized() {
                  return !liff.id;
                };

                initLineLiffApp = /*#__PURE__*/function () {
                  var _ref2 = (0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    return _home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.prev = 0;

                            if (!(liffId && isNotLiffInitialized())) {
                              _context.next = 4;
                              break;
                            }

                            _context.next = 4;
                            return liff.init({
                              liffId: liffId
                            });

                          case 4:
                            _context.next = 9;
                            break;

                          case 6:
                            _context.prev = 6;
                            _context.t0 = _context["catch"](0);
                            // liffが初期化できなくてもuserにfeedbackする必要はないのでconsole.errorしておく
                            console.error('liff init error', _context.t0.message);

                          case 9:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, null, [[0, 6]]);
                  }));

                  return function initLineLiffApp() {
                    return _ref2.apply(this, arguments);
                  };
                }();

                setToken = /*#__PURE__*/function () {
                  var _ref3 = (0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2() {
                    var token;
                    return _home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            setIsLoading(true);
                            _context2.prev = 1;

                            if (!liff.isInClient()) {
                              _context2.next = 7;
                              break;
                            }

                            _context2.next = 5;
                            return liff.ready;

                          case 5:
                            token = liff.getAccessToken();
                            setLineAccessToken(token);

                          case 7:
                            _context2.next = 12;
                            break;

                          case 9:
                            _context2.prev = 9;
                            _context2.t0 = _context2["catch"](1);
                            console.error(_context2.t0.message);

                          case 12:
                            _context2.prev = 12;
                            setIsLoading(false);
                            return _context2.finish(12);

                          case 15:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2, null, [[1, 9, 12, 15]]);
                  }));

                  return function setToken() {
                    return _ref3.apply(this, arguments);
                  };
                }();

                _context3.next = 6;
                return initLineLiffApp();

              case 6:
                _context3.next = 8;
                return setToken();

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
  }, [liffId]);
  return {
    lineAccessToken: lineAccessToken,
    isLoading: isLoading
  };
};

/***/ }),

/***/ 8561:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86896);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5402);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);






var LineMiniAppButtonLink = function LineMiniAppButtonLink(_ref) {
  var liffId = _ref.liffId,
      path = _ref.path,
      hash = _ref.hash;
  var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
  var miniAppUrl = new URL('https://liff.line.me');
  var pathname = path ? liffId + path : liffId;
  miniAppUrl.pathname = pathname;

  if (hash) {
    miniAppUrl.hash = hash;
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()((_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default().container)),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("a", {
      href: miniAppUrl.toString(),
      className: classnames__WEBPACK_IMPORTED_MODULE_0___default()((_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default().link_button)),
      children: intl.formatMessage({
        id: 'lineMiniAppLinkButton.reserveByLine'
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (LineMiniAppButtonLink);

/***/ }),

/***/ 30446:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ merchant_MerchantProfile; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(92777);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(82262);
;// CONCATENATED MODULE: ./src/components/utils/DateTimeUtils.ts



// TODO: Refactoring
var DateTimeUtils = /*#__PURE__*/function () {
  function DateTimeUtils() {
    (0,classCallCheck/* default */.Z)(this, DateTimeUtils);
  }

  (0,createClass/* default */.Z)(DateTimeUtils, null, [{
    key: "formatWeekday",
    value: function formatWeekday(dayNumber) {
      switch (dayNumber) {
        case 0:
          return '日';

        case 1:
          return '月';

        case 2:
          return '火';

        case 3:
          return '水';

        case 4:
          return '木';

        case 5:
          return '金';

        case 6:
          return '土';

        default:
          return '';
      }
    }
  }, {
    key: "formatBusinessHours",
    value: function formatBusinessHours(businessHours) {
      var result = [];
      var weekdays = DateTimeUtils.getWeekdays(businessHours);
      var monday = weekdays[0];

      if (DateTimeUtils.isWeekdayEverySameTime(weekdays, monday)) {
        // eslint-disable-next-line no-irregular-whitespace
        result.push(DateTimeUtils.formatBizHourString('月〜金', monday.opening_hour, monday.closing_hour));
      } else {
        weekdays.forEach(function (d) {
          if (d.is_open) {
            result.push(DateTimeUtils.formatOpenBusinessHour(d));
          } else {
            result.push(DateTimeUtils.formatCloseBusinessHour(d));
          }
        });
      }

      var weekend = DateTimeUtils.getWeekend(businessHours);
      var sunday = weekend[0];

      if (DateTimeUtils.isWeekendEverySameTime(weekend, sunday)) {
        // eslint-disable-next-line no-irregular-whitespace
        result.push(DateTimeUtils.formatBizHourString('土・日', sunday.opening_hour, sunday.closing_hour));
      } else {
        weekend.reverse().forEach(function (d) {
          if (d.is_open) {
            result.push(DateTimeUtils.formatOpenBusinessHour(d));
          } else {
            result.push(DateTimeUtils.formatCloseBusinessHour(d));
          }
        });
      }

      return result;
    }
  }, {
    key: "getWeekdays",
    value: function getWeekdays(businessHours) {
      return businessHours.filter(function (v) {
        return v.weekday > 0 && v.weekday < 6;
      });
    }
  }, {
    key: "getWeekend",
    value: function getWeekend(businessHours) {
      return businessHours.filter(function (v) {
        return v.weekday === 0 || v.weekday === 6;
      });
    }
  }, {
    key: "isWeekdayEverySameTime",
    value: function isWeekdayEverySameTime(weekdays, monday) {
      return weekdays.every(function (d) {
        return d.is_open && monday.opening_hour === d.opening_hour && monday.closing_hour === d.closing_hour;
      });
    }
  }, {
    key: "isWeekendEverySameTime",
    value: function isWeekendEverySameTime(weekdays, sunday) {
      return weekdays.every(function (d) {
        return d.is_open && sunday.opening_hour === d.opening_hour && sunday.closing_hour === d.closing_hour;
      });
    }
  }, {
    key: "formatOpenBusinessHour",
    value: function formatOpenBusinessHour(date) {
      var weekday = DateTimeUtils.formatWeekday(date.weekday);
      var open = date.opening_hour;
      var close = date.closing_hour; // eslint-disable-next-line no-irregular-whitespace

      return DateTimeUtils.formatBizHourString(weekday, open, close);
    }
  }, {
    key: "formatCloseBusinessHour",
    value: function formatCloseBusinessHour(date) {
      var weekday = DateTimeUtils.formatWeekday(date.weekday); // eslint-disable-next-line no-irregular-whitespace

      return "".concat(weekday, "\u3000\u5B9A\u4F11\u65E5\n");
    }
  }, {
    key: "formatBizHourString",
    value: function formatBizHourString(week, open, close) {
      return "".concat(week, "\u3000").concat(open.substring(0, 5), " - ").concat(close.substring(0, 5), "\n");
    }
  }]);

  return DateTimeUtils;
}();

/* harmony default export */ var utils_DateTimeUtils = (DateTimeUtils);
// EXTERNAL MODULE: ./src/components/utils/StringUtils.tsx
var StringUtils = __webpack_require__(16197);
// EXTERNAL MODULE: ./src/molecules/merchant/MerchantProfile/MerchantProfile.module.scss
var MerchantProfile_module = __webpack_require__(10826);
var MerchantProfile_module_default = /*#__PURE__*/__webpack_require__.n(MerchantProfile_module);
// EXTERNAL MODULE: ./node_modules/date-fns/index.js
var date_fns = __webpack_require__(47292);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/molecules/merchant/MerchantProfile/index.tsx










function formatTemporaryDateWithWeekday(date) {
  var dateText = (0,date_fns.format)(new Date(date), 'YYYY/MM/DD');
  var weekday = utils_DateTimeUtils.formatWeekday((0,date_fns.getDay)(new Date(date)));
  return dateText + '（' + weekday + '）';
}

function formatTemporaryBusinessHour(temporaryDate) {
  var temporaryBusinessHour = {
    date: '',
    hours: []
  };
  temporaryBusinessHour.date = formatTemporaryDateWithWeekday(temporaryDate.start_at);
  temporaryDate.temporary_hours.forEach(function (h) {
    var startHour = (0,date_fns.format)(new Date(h.start_at), 'HH:mm');
    var endHour = (0,date_fns.format)(new Date(h.end_at), 'HH:mm');

    if (endHour === '00:00') {
      endHour = '24:00';
    }

    temporaryBusinessHour.hours.push(startHour + ' - ' + endHour);
  });
  return temporaryBusinessHour;
}

function formatTemporaryClosingDay(temporaryDate) {
  var temporaryClosingDays = {
    startDate: '',
    endDate: '',
    reason: ''
  };
  temporaryClosingDays.startDate = formatTemporaryDateWithWeekday(temporaryDate.start_at);
  temporaryClosingDays.endDate = formatTemporaryDateWithWeekday((0,date_fns.addDays)(temporaryDate.end_at, -1));

  if (temporaryDate.reason) {
    temporaryClosingDays.reason = temporaryDate.reason;
  }

  return temporaryClosingDays;
}

function temporaryDatesText(temporaryDates) {
  var result = {
    temporaryBusinessHours: [],
    temporaryClosingDays: []
  };
  temporaryDates.forEach(function (_ref) {
    var type = _ref.type,
        start_at = _ref.start_at,
        end_at = _ref.end_at,
        temporary_hours = _ref.temporary_hours,
        reason = _ref.reason;

    if (type === 'open') {
      var formatTemporaryBusinessHourProps = {
        start_at: start_at,
        end_at: end_at,
        temporary_hours: temporary_hours
      };
      result.temporaryBusinessHours.push(formatTemporaryBusinessHour(formatTemporaryBusinessHourProps));
    } else {
      formatTemporaryClosingDay;
      var formatTemporaryClosingDayProps = {
        start_at: start_at,
        end_at: end_at,
        reason: reason
      };
      result.temporaryClosingDays.push(formatTemporaryClosingDay(formatTemporaryClosingDayProps));
    }
  });
  return result;
}

var MerchantProfile = function MerchantProfile(_ref2) {
  var merchantDetail = _ref2.merchantDetail;
  var intl = (0,useIntl/* default */.Z)();
  var addressLink = merchantDetail.address ? "https://www.google.co.jp/maps/place/".concat(encodeURI(merchantDetail.address.replace(/\r?\n/g, ' '))) : undefined;
  var businessHoursTexts = [];

  if (merchantDetail.business_hours.length > 0) {
    businessHoursTexts = utils_DateTimeUtils.formatBusinessHours(merchantDetail.business_hours);
  }

  var temporaryHoursTexts = merchantDetail.temporary_dates ? temporaryDatesText(merchantDetail.temporary_dates) : undefined;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("dl", {
    className: (MerchantProfile_module_default()).MerchantProfile,
    children: [merchantDetail.address && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (MerchantProfile_module_default()).MerchantProfile__Row,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("dt", {
        className: (MerchantProfile_module_default()).MerchantProfile__RowHead,
        children: intl.formatMessage({
          id: 'merchants.details.address'
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("dd", {
        className: (MerchantProfile_module_default()).MerchantProfile__RowContent,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: StringUtils/* default.nl2br */.Z.nl2br(merchantDetail.address)
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          className: (MerchantProfile_module_default()).MerchantProfile__RowBodySubLink,
          href: addressLink,
          target: "_blank",
          rel: "noopener noreferrer",
          children: intl.formatMessage({
            id: 'merchants.details.openMap'
          })
        })]
      })]
    }), merchantDetail.phone_number && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (MerchantProfile_module_default()).MerchantProfile__Row,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("dt", {
        className: (MerchantProfile_module_default()).MerchantProfile__RowHead,
        children: intl.formatMessage({
          id: 'merchants.details.phoneNumber'
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("dd", {
        className: (MerchantProfile_module_default()).MerchantProfile__RowContent,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "tel:".concat(merchantDetail.phone_number),
          children: merchantDetail.phone_number
        })
      })]
    }), merchantDetail.merchant_setting.show_business_hours && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [businessHoursTexts.length !== 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (MerchantProfile_module_default()).MerchantProfile__Row,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("dt", {
          className: (MerchantProfile_module_default()).MerchantProfile__RowHead,
          children: intl.formatMessage({
            id: 'merchants.details.businessHours'
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("dd", {
          className: (MerchantProfile_module_default()).MerchantProfile__RowContent,
          children: businessHoursTexts.map(function (txt, i) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: (MerchantProfile_module_default()).MerchantProfile__BusinessHourText,
              children: txt
            }, "".concat(txt).concat(i));
          })
        })]
      }), temporaryHoursTexts && temporaryHoursTexts.temporaryBusinessHours.length !== 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (MerchantProfile_module_default()).MerchantProfile__Row,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("dt", {
          className: (MerchantProfile_module_default()).MerchantProfile__RowHead,
          children: intl.formatMessage({
            id: 'merchants.details.temporaryBusinessHours'
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("table", {
          className: (MerchantProfile_module_default()).MerchantProfile__RowContent,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("tbody", {
            children: temporaryHoursTexts.temporaryBusinessHours.map(function (temporaryBusinessHour) {
              return /*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                  className: (MerchantProfile_module_default()).MerchantProfile__TemporaryDateTextCell,
                  children: temporaryBusinessHour.date
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                  className: (MerchantProfile_module_default()).MerchantProfile__TemporaryDateSubTextCell,
                  children: temporaryBusinessHour.hours.map(function (hour) {
                    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      children: hour
                    });
                  })
                })]
              }, temporaryBusinessHour.date);
            })
          })
        })]
      }), temporaryHoursTexts && temporaryHoursTexts.temporaryClosingDays.length !== 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (MerchantProfile_module_default()).MerchantProfile__Row,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("dt", {
          className: (MerchantProfile_module_default()).MerchantProfile__RowHead,
          children: intl.formatMessage({
            id: 'merchants.details.temporaryClosingDays'
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("table", {
          className: (MerchantProfile_module_default()).MerchantProfile__RowContent,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("tbody", {
            children: temporaryHoursTexts.temporaryClosingDays.map(function (temporaryClosingDay) {
              return /*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                  className: (MerchantProfile_module_default()).MerchantProfile__TemporaryDateTextCell,
                  children: temporaryClosingDay.startDate === temporaryClosingDay.endDate ? temporaryClosingDay.startDate : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [temporaryClosingDay.startDate, " - ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), temporaryClosingDay.endDate]
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                  className: (MerchantProfile_module_default()).MerchantProfile__TemporaryDateSubTextCell,
                  children: temporaryClosingDay.reason
                })]
              }, temporaryClosingDay.startDate);
            })
          })
        })]
      })]
    })]
  });
};

/* harmony default export */ var merchant_MerchantProfile = (MerchantProfile);

/***/ }),

/***/ 17105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _components_LineTruncate__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56922);
/* harmony import */ var _tags_MerchantTag__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16564);
/* harmony import */ var _texts_LowestPrice__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17132);
/* harmony import */ var _BookingPageCard_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(20655);
/* harmony import */ var _BookingPageCard_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_BookingPageCard_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);










var BookingPageCard = function BookingPageCard(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()((_BookingPageCard_module_scss__WEBPACK_IMPORTED_MODULE_7___default().BookingPageCard), props.className),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
      href: props.url,
      prefetch: false,
      className: (_BookingPageCard_module_scss__WEBPACK_IMPORTED_MODULE_7___default().BookingPageCard__Link),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
        children: [props.thumbnailUrl && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: (_BookingPageCard_module_scss__WEBPACK_IMPORTED_MODULE_7___default().BookingPageCard__Thumbnail),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
            className: (_BookingPageCard_module_scss__WEBPACK_IMPORTED_MODULE_7___default().BookingPageCard__ThumbnailImage),
            style: {
              backgroundImage: "url(".concat(props.thumbnailUrl, ")")
            }
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: (_BookingPageCard_module_scss__WEBPACK_IMPORTED_MODULE_7___default().BookingPageCard__Heading),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_LineTruncate__WEBPACK_IMPORTED_MODULE_3__/* .SingleLineTruncate */ .d, {
            maxLine: 2,
            text: props.title
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: (_BookingPageCard_module_scss__WEBPACK_IMPORTED_MODULE_7___default().BookingPageCard__Description),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_LineTruncate__WEBPACK_IMPORTED_MODULE_3__/* .MultipleLineTruncate */ .Q, {
            maxLine: 3,
            text: props.description
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: (_BookingPageCard_module_scss__WEBPACK_IMPORTED_MODULE_7___default().BookingPageCard__Clearfix)
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
        className: (_BookingPageCard_module_scss__WEBPACK_IMPORTED_MODULE_7___default().BookingPageCard__Footer),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: (_BookingPageCard_module_scss__WEBPACK_IMPORTED_MODULE_7___default().BookingPageCard__Tags),
          children: props.tags && props.tags.length > 0 && props.tags.map(function (tag, i) {
            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_tags_MerchantTag__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
              status: tag
            }, i);
          })
        }), props.lowestPrice !== undefined && props.lowestPrice !== null && props.uniquePricing !== undefined && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: (_BookingPageCard_module_scss__WEBPACK_IMPORTED_MODULE_7___default().BookingPageCard__Price),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_texts_LowestPrice__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            lowestPrice: props.lowestPrice,
            uniquePricing: props.uniquePricing
          })
        })]
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (BookingPageCard);

/***/ }),

/***/ 16564:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6292);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(20320);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86896);
/* harmony import */ var _atoms_Tag__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49044);
/* harmony import */ var _MerchantTag_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77050);
/* harmony import */ var _MerchantTag_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_MerchantTag_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);








var MerchantTag = function MerchantTag(_ref) {
  var status = _ref.status;
  var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();

  var classes = function classes(courseStatus) {
    return classnames__WEBPACK_IMPORTED_MODULE_0___default()((_MerchantTag_module_scss__WEBPACK_IMPORTED_MODULE_5___default().MerchantTag), (_MerchantTag_module_scss__WEBPACK_IMPORTED_MODULE_5___default())["is".concat((0,lodash_es__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,lodash_es__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(courseStatus)))]);
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_atoms_Tag__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    className: classes(status),
    children: intl.formatMessage({
      id: "merchants.bookingPages.status.".concat((0,lodash_es__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(status))
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (MerchantTag);

/***/ }),

/***/ 17132:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86896);
/* harmony import */ var _LowestPrice_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92706);
/* harmony import */ var _LowestPrice_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_LowestPrice_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);








var LowestPrice = function LowestPrice(props) {
  var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
  return props.lowestPrice == null ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {}) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("span", {
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()((_LowestPrice_module_scss__WEBPACK_IMPORTED_MODULE_4___default().LowestPrice), props.className),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
      className: (_LowestPrice_module_scss__WEBPACK_IMPORTED_MODULE_4___default().LowestPrice__Emphasis),
      children: intl.formatNumber(props.lowestPrice)
    }), intl.formatMessage({
      id: props.uniquePricing ? 'merchants.common.lowestPrice.single_unit' : 'merchants.common.lowestPrice.multi_unit'
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (LowestPrice);

/***/ }),

/***/ 41807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ booking_pages; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
// EXTERNAL MODULE: ./src/components/layouts/JsonLd.tsx
var JsonLd = __webpack_require__(26411);
// EXTERNAL MODULE: ./src/components/layouts/MetaTags.tsx
var MetaTags = __webpack_require__(92651);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/rc-pagination/es/index.js + 18 modules
var es = __webpack_require__(66455);
// EXTERNAL MODULE: ./src/atoms/buttons/Button/index.tsx
var Button = __webpack_require__(48413);
// EXTERNAL MODULE: ./src/atoms/Heading/index.tsx
var Heading = __webpack_require__(44407);
// EXTERNAL MODULE: ./src/organisms/merchants/BaseTemplate/index.tsx + 6 modules
var BaseTemplate = __webpack_require__(74831);
// EXTERNAL MODULE: ./src/molecules/merchant/common/cards/BookingPageCard/index.tsx
var BookingPageCard = __webpack_require__(17105);
// EXTERNAL MODULE: ./src/molecules/merchant/MerchantProfile/index.tsx + 1 modules
var MerchantProfile = __webpack_require__(30446);
// EXTERNAL MODULE: ./src/hooks/line-liff/index.ts
var line_liff = __webpack_require__(13656);
// EXTERNAL MODULE: ./src/molecules/line/LineMiniAppButtonLink/index.tsx
var LineMiniAppButtonLink = __webpack_require__(8561);
// EXTERNAL MODULE: ./src/templates/merchants/booking-pages/IndexTemplate/MerchantBookingServicesPage.module.scss
var MerchantBookingServicesPage_module = __webpack_require__(49316);
var MerchantBookingServicesPage_module_default = /*#__PURE__*/__webpack_require__.n(MerchantBookingServicesPage_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/templates/merchants/booking-pages/IndexTemplate/MerchantBookingServicesPage.tsx















var MerchantBookingServicesPage = function MerchantBookingServicesPage(_ref) {
  var bookingPages = _ref.bookingPages,
      merchantDetail = _ref.merchantDetail,
      _ref$pagination = _ref.pagination,
      totalSize = _ref$pagination.totalSize,
      currentPage = _ref$pagination.currentPage,
      isCoubicApp = _ref.isCoubicApp;
  var intl = (0,useIntl/* default */.Z)();
  var handlePageChange = (0,react.useCallback)(function (page) {
    location.href = "".concat(location.pathname, "?page=").concat(page, "#pageContent");
  }, []);

  var _useLineLiffAccessTok = (0,line_liff/* useLineLiffAccessToken */.Q)(merchantDetail.line_liff_id),
      lineAccessToken = _useLineLiffAccessTok.lineAccessToken;

  var isNotFromLineMiniApp = lineAccessToken === null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (MerchantBookingServicesPage_module_default()).MerchantBookingServicesPage,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(BaseTemplate/* default */.Z, {
      merchantDetail: merchantDetail,
      isCoubicApp: isCoubicApp,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (MerchantBookingServicesPage_module_default()).MerchantBookingServicesPage__Content,
        children: [merchantDetail.line_liff_id && isNotFromLineMiniApp && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (MerchantBookingServicesPage_module_default()).line_mini_app_link,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LineMiniAppButtonLink/* default */.Z, {
            liffId: merchantDetail.line_liff_id,
            path: "/booking_pages",
            hash: "#pageContent"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: (MerchantBookingServicesPage_module_default()).line_mini_app_description,
            children: intl.formatMessage({
              id: 'merchants.details.canReceiveMessageFromLINE'
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Heading/* default */.Z, {
          className: (MerchantBookingServicesPage_module_default()).MerchantBookingServicesPage__Heading,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/".concat(merchantDetail.public_id, "/booking_pages#pageContent"),
            prefetch: false,
            className: (MerchantBookingServicesPage_module_default()).MerchantBookingServicesPage__Link,
            children: intl.formatMessage({
              id: 'merchants.bookingPages.index.title'
            })
          }), currentPage > 1 && " ".concat(intl.formatMessage({
            id: 'merchants.bookingPages.index.page'
          }, {
            currentPage: currentPage
          }))]
        }), bookingPages.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: bookingPages.map(function (bookingPage) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(BookingPageCard/* default */.Z, {
              className: (MerchantBookingServicesPage_module_default()).MerchantBookingServicesPage__BookingPageCard,
              title: bookingPage.name,
              description: bookingPage.description.text || '',
              url: "/".concat(merchantDetail.public_id, "/").concat(bookingPage.publicId, "#pageContent"),
              thumbnailUrl: bookingPage.thumbnailUrl,
              tags: bookingPage.tagNames,
              lowestPrice: bookingPage.lowestPrice,
              uniquePricing: bookingPage.uniquePricing
            }, bookingPage.publicId);
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (MerchantBookingServicesPage_module_default()).MerchantBookingServicesPage__Pager,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(es/* default */.Z, {
            onChange: handlePageChange,
            current: currentPage,
            total: totalSize,
            showTitle: false
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (MerchantBookingServicesPage_module_default()).MerchantBookingServicesPage__MerchantProfileSection,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* default */.Z, {
            className: (MerchantBookingServicesPage_module_default()).MerchantBookingServicesPage__Heading,
            children: intl.formatMessage({
              id: 'merchants.details.storeData'
            }, {
              displayName: merchantDetail.display_name
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(MerchantProfile/* default */.Z, {
            merchantDetail: merchantDetail
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (MerchantBookingServicesPage_module_default()).MerchantBookingServicesPage__BackToTopButtonSection,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.ZP, {
              className_Deprecated: (MerchantBookingServicesPage_module_default()).MerchantBookingServicesPage__BackToTopButton,
              isGhost: true,
              isFull: true,
              href: "/".concat(merchantDetail.public_id),
              buttonSize: Button/* ButtonSize.Medium */.qE.Medium,
              children: intl.formatMessage({
                id: 'merchants.details.backToMerchantTop'
              }, {
                displayName: merchantDetail.display_name
              })
            })
          })]
        })]
      })
    })
  });
};

/* harmony default export */ var IndexTemplate_MerchantBookingServicesPage = (MerchantBookingServicesPage);
// EXTERNAL MODULE: ./src/templates/ErrorTemplate/index.tsx + 5 modules
var ErrorTemplate = __webpack_require__(37602);
// EXTERNAL MODULE: ./src/components/MerchantSite/index.tsx
var MerchantSite = __webpack_require__(7818);
// EXTERNAL MODULE: ./src/hooks/gtm/index.ts
var gtm = __webpack_require__(51295);
;// CONCATENATED MODULE: ./src/pages/[publicId]/booking_pages/index.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }













var titleBy = function titleBy(intl, displayName, currentPage) {
  var base = intl.formatMessage({
    id: 'merchants.bookingPages.index.meta.title'
  }, {
    displayName: displayName
  });

  if (currentPage <= 1) {
    return base;
  }

  return "".concat(base, " ").concat(intl.formatMessage({
    id: 'merchants.bookingPages.index.page'
  }, {
    currentPage: currentPage
  }));
};

var BookingPages = function BookingPages(_ref) {
  var public_id = _ref.public_id,
      merchantDetail = _ref.merchantDetail,
      category = _ref.category,
      bookingPages = _ref.bookingPages,
      pagination = _ref.pagination,
      isCoubicApp = _ref.isCoubicApp;
  var intl = (0,useIntl/* default */.Z)();
  var currentPage = pagination === null || pagination === void 0 ? void 0 : pagination.currentPage;
  (0,gtm/* usePushMerchantDataLayerEffect */.O)({
    visit_merchant_id: merchantDetail === null || merchantDetail === void 0 ? void 0 : merchantDetail.id
  });

  if (merchantDetail && category && pagination && currentPage && bookingPages) {
    var _merchantDetail$seo_s, _merchantDetail$seo_s2, _merchantDetail$seo_s3, _merchantDetail$favic;

    var title = titleBy(intl, merchantDetail.display_name, currentPage);
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(MetaTags/* default */.Z, {
        title: title,
        description: ((_merchantDetail$seo_s = merchantDetail.seo_setting) === null || _merchantDetail$seo_s === void 0 ? void 0 : _merchantDetail$seo_s.description) || merchantDetail.description,
        keywords: ((_merchantDetail$seo_s2 = merchantDetail.seo_setting) === null || _merchantDetail$seo_s2 === void 0 ? void 0 : _merchantDetail$seo_s2.keyword) || '',
        thumbnailUrl: merchantDetail.cover_image.url || '',
        currentUrl: "".concat(MetaTags/* COUBIC_ORIGIN */._, "/").concat(merchantDetail.public_id, "/booking_pages?page=").concat(currentPage),
        noIndex: (_merchantDetail$seo_s3 = merchantDetail.seo_setting) === null || _merchantDetail$seo_s3 === void 0 ? void 0 : _merchantDetail$seo_s3.no_index,
        googleAnalyticsFourTrackingId: merchantDetail.available_google_analytics_four_tracking_id,
        faviconImageUrl: merchantDetail === null || merchantDetail === void 0 ? void 0 : (_merchantDetail$favic = merchantDetail.favicon_image) === null || _merchantDetail$favic === void 0 ? void 0 : _merchantDetail$favic.url
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(JsonLd/* default */.Z, {
        merchant: merchantDetail
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(IndexTemplate_MerchantBookingServicesPage, {
        merchantDetail: merchantDetail,
        public_id: public_id,
        category: category,
        bookingPages: bookingPages,
        pagination: pagination,
        isCoubicApp: isCoubicApp
      })]
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorTemplate/* default */.Z, {
    statusCode: 404
  });
};

var MerchantBookingPages = function MerchantBookingPages(props) {
  var merchantDetail = props.merchantDetail,
      isUnpublishedSite = props.isUnpublishedSite;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(MerchantSite/* MerchantSite */.Z, {
    isUnPublished: isUnpublishedSite,
    isMerchantInfoExist: !!merchantDetail,
    logoImage: (merchantDetail === null || merchantDetail === void 0 ? void 0 : merchantDetail.logo_image) || null,
    merchantPublicId: (merchantDetail === null || merchantDetail === void 0 ? void 0 : merchantDetail.public_id) || null,
    displayName: (merchantDetail === null || merchantDetail === void 0 ? void 0 : merchantDetail.display_name) || null,
    isCoubicApp: props.isCoubicApp,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(BookingPages, _objectSpread({}, props))
  });
};

var __N_SSP = true;
/* harmony default export */ var booking_pages = (MerchantBookingPages);

/***/ }),

/***/ 56773:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[publicId]/booking_pages",
      function () {
        return __webpack_require__(41807);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 28742:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Tag":"Tag_Tag__MEuQu","isGray":"Tag_isGray__DYThc"};

/***/ }),

/***/ 5402:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__8n02_","link_button":"style_link_button__UC_7B"};

/***/ }),

/***/ 10826:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"MerchantProfile":"MerchantProfile_MerchantProfile___rUs_","MerchantProfile__Row":"MerchantProfile_MerchantProfile__Row__9_UOy","MerchantProfile__RowHead":"MerchantProfile_MerchantProfile__RowHead__9CUjM","MerchantProfile__RowContent":"MerchantProfile_MerchantProfile__RowContent__Xnng2","MerchantProfile__RowBodySubLink":"MerchantProfile_MerchantProfile__RowBodySubLink__GORkO","MerchantProfile__BusinessHourText":"MerchantProfile_MerchantProfile__BusinessHourText__w03Fg","MerchantProfile__TemporaryDateTextCell":"MerchantProfile_MerchantProfile__TemporaryDateTextCell__jdc2r","MerchantProfile__TemporaryDateSubTextCell":"MerchantProfile_MerchantProfile__TemporaryDateSubTextCell__6ncRR"};

/***/ }),

/***/ 20655:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"BookingPageCard":"BookingPageCard_BookingPageCard__fmwb5","BookingPageCard__Link":"BookingPageCard_BookingPageCard__Link__M2dAw","BookingPageCard__Thumbnail":"BookingPageCard_BookingPageCard__Thumbnail__JhxU6","BookingPageCard__ThumbnailImage":"BookingPageCard_BookingPageCard__ThumbnailImage__V82jf","BookingPageCard__Heading":"BookingPageCard_BookingPageCard__Heading__vbzvC","BookingPageCard__Description":"BookingPageCard_BookingPageCard__Description__j9zJ2","BookingPageCard__Clearfix":"BookingPageCard_BookingPageCard__Clearfix__Gzhzu","BookingPageCard__Footer":"BookingPageCard_BookingPageCard__Footer__DUxiB","BookingPageCard__Price":"BookingPageCard_BookingPageCard__Price__obXSG","BookingPageCard__Tags":"BookingPageCard_BookingPageCard__Tags__8_j0q"};

/***/ }),

/***/ 77050:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"MerchantTag":"MerchantTag_MerchantTag__gr0Qn","isAccepting":"MerchantTag_isAccepting__Hr8x5","isClosed":"MerchantTag_isClosed__H2nnX","isCreditCard":"MerchantTag_isCreditCard__7_X0t","isOnsite":"MerchantTag_isOnsite__m7Lh_","isBankTransfer":"MerchantTag_isBankTransfer__7PFCW","isTicket":"MerchantTag_isTicket__S93zM","isSubscription":"MerchantTag_isSubscription__lye9M","isRequireAcceptance":"MerchantTag_isRequireAcceptance__YSDbw"};

/***/ }),

/***/ 92706:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"LowestPrice":"LowestPrice_LowestPrice__ZU1tL","LowestPrice__Emphasis":"LowestPrice_LowestPrice__Emphasis__5HvM8"};

/***/ }),

/***/ 49316:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"MerchantBookingServicesPage":"MerchantBookingServicesPage_MerchantBookingServicesPage__3CLD3","MerchantBookingServicesPage__Content":"MerchantBookingServicesPage_MerchantBookingServicesPage__Content___D4t_","MerchantBookingServicesPage__Heading":"MerchantBookingServicesPage_MerchantBookingServicesPage__Heading___neVU","MerchantBookingServicesPage__Link":"MerchantBookingServicesPage_MerchantBookingServicesPage__Link__xTBuF","MerchantBookingServicesPage__BookingPageCard":"MerchantBookingServicesPage_MerchantBookingServicesPage__BookingPageCard__Dg02S","MerchantBookingServicesPage__Pager":"MerchantBookingServicesPage_MerchantBookingServicesPage__Pager__L5hJ7","MerchantBookingServicesPage__MerchantProfileSection":"MerchantBookingServicesPage_MerchantBookingServicesPage__MerchantProfileSection___hVSw","MerchantBookingServicesPage__BackToTopButtonSection":"MerchantBookingServicesPage_MerchantBookingServicesPage__BackToTopButtonSection__huBj8","MerchantBookingServicesPage__BackToTopButton":"MerchantBookingServicesPage_MerchantBookingServicesPage__BackToTopButton___cnAV","line_mini_app_link":"MerchantBookingServicesPage_line_mini_app_link__P5eDf","line_mini_app_description":"MerchantBookingServicesPage_line_mini_app_description__8Sp2o"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1966,2595,8888,5974,9267,320,6455,1878,7356,719,3202,4754,9774,2888,179], function() { return __webpack_exec__(56773); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);